export const activityConstants = {

    FETCH_ACTIVITIES_REQUEST: 'FETCH_ACTIVITIES_REQUEST',
    FETCH_ACTIVITIES_SUCCESS: 'FETCH_ACTIVITIES_SUCCESS',
    FETCH_ACTIVITIES_FAILURE: 'FETCH_ACTIVITIES_FAILURE',

    CREATE_ACTIVITY_REQUEST: 'CREATE_ACTIVITY_REQUEST',
    CREATE_ACTIVITY_SUCCESS: 'CREATE_ACTIVITY_SUCCESS',
    CREATE_ACTIVITY_FAILURE: 'CREATE_ACTIVITY_FAILURE',

    UPDATE_ACTIVITY_REQUEST: 'UPDATE_ACTIVITY_REQUEST',
    UPDATE_ACTIVITY_SUCCESS: 'UPDATE_ACTIVITY_SUCCESS',
    UPDATE_ACTIVITY_FAILURE: 'UPDATE_ACTIVITY_FAILURE',

    DELETE_ACTIVITY_REQUEST: 'DELETE_ACTIVITY_REQUEST',
    DELETE_ACTIVITY_SUCCESS: 'DELETE_ACTIVITY_SUCCESS',
    DELETE_ACTIVITY_FAILURE: 'DELETE_ACTIVITY_FAILURE',

}